import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AccountsEffects } from './store/effects/accounts.effects';
import { reducers } from './store/reducers/accounts.reducers';
import { UsersRoutingModule } from './users-routing.module';
import { ExportModule } from '../../shared/modules/export/export.module';
import { ExportEffects } from './store/effects/export.effects';

@NgModule({
    imports: [
        CommonModule,
        UsersRoutingModule,
        StoreModule.forFeature('momint-accounts', reducers),
        EffectsModule.forFeature([AccountsEffects, ExportEffects]),
        ExportModule,
    ],
})
export class UsersModule {}
